import {updatePlantById} from "../../services/Administrative/plantService";
import {useState} from "react";

export const useUpdatePlantById = () => {

    const [loadingUpdate, setLoadingUpdate] = useState<boolean>(false);

    const updatePlant = async (plantDto: any) => {
        try {
            setLoadingUpdate(true);
            return await updatePlantById(plantDto);
        } catch (error:any) {
            throw Error(error.message);
        }
        finally {
            setTimeout(() => { setLoadingUpdate(false) }, 600)
        }
    };

    return { updatePlant, loadingUpdate };
};
